var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26,
    fill: "#CFD9F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 14.918L38.375 10.043M38.375 10.043L43.25 14.918M38.375 10.043V19.793M27.8125 11.668H20.175C17.4447 11.668 16.0796 11.668 15.0368 12.1993C14.1195 12.6667 13.3737 13.4125 12.9063 14.3298C12.375 15.3726 12.375 16.7377 12.375 19.468V33.118C12.375 35.8482 12.375 37.2134 12.9063 38.2562C13.3737 39.1735 14.1195 39.9192 15.0368 40.3866C16.0796 40.918 17.4447 40.918 20.175 40.918H35.125C36.6362 40.918 37.3918 40.918 38.0117 40.7519C39.6941 40.3011 41.0081 38.987 41.4589 37.3047C41.625 36.6848 41.625 35.9292 41.625 34.418M24.5625 20.6055C24.5625 22.4004 23.1074 23.8555 21.3125 23.8555C19.5176 23.8555 18.0625 22.4004 18.0625 20.6055C18.0625 18.8105 19.5176 17.3555 21.3125 17.3555C23.1074 17.3555 24.5625 18.8105 24.5625 20.6055ZM31.8588 26.16L18.1131 38.656C17.34 39.3589 16.9534 39.7103 16.9192 40.0148C16.8896 40.2787 16.9907 40.5404 17.1902 40.7157C17.4203 40.918 17.9427 40.918 18.9876 40.918H34.241C36.5796 40.918 37.7489 40.918 38.6674 40.5251C39.8203 40.0319 40.7389 39.1133 41.2321 37.9603C41.625 37.0419 41.625 35.8726 41.625 33.5339C41.625 32.7471 41.625 32.3536 41.539 31.9872C41.4309 31.5267 41.2236 31.0954 40.9315 30.7234C40.6992 30.4273 40.3919 30.1815 39.7775 29.69L35.232 26.0535C34.617 25.5616 34.3095 25.3156 33.9709 25.2288C33.6725 25.1523 33.3584 25.1622 33.0654 25.2573C32.7329 25.3653 32.4415 25.6302 31.8588 26.16Z",
    stroke: "#2948A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.48e4062aa1992fda634432896fdc00eb.svg";
export { ForwardRef as ReactComponent };